// SPDX-License-Identifier: LicenseRef-Proprietary
import React from 'react';

interface KPICardProps {
  label: string;
  value: string;
  hint?: string;
  'aria-label'?: string;
}

export const KPICard: React.FC<KPICardProps> = ({
  label,
  value,
  hint,
  'aria-label': ariaLabel,
}) => {
  return (
    <div 
      className="vaccine-demo__kpi-card"
      role="region"
      aria-label={ariaLabel || `${label}: ${value}`}
    >
      <div className="vaccine-demo__kpi-label">{label}</div>
      <div className="vaccine-demo__kpi-value">{value}</div>
      {hint && (
        <div className="vaccine-demo__kpi-hint" aria-hidden="true">
          {hint}
        </div>
      )}
    </div>
  );
};
